import { render, staticRenderFns } from "./TwProcessGroupListEditCustomer.vue?vue&type=template&id=63d17b8f&scoped=true&"
import script from "./TwProcessGroupListEditCustomer.vue?vue&type=script&lang=js&"
export * from "./TwProcessGroupListEditCustomer.vue?vue&type=script&lang=js&"
import style0 from "./TwProcessGroupListEditCustomer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TwProcessGroupListEditCustomer.vue?vue&type=style&index=1&id=63d17b8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d17b8f",
  null
  
)

export default component.exports